<template>
  <div class="accept-pdpa">
    <div class="title">{{ $t('AcceptPdpa.title') }}</div>
    <div class="content" v-html="input"></div>
    <div class="action">
      <button class="cancel-button" @click="$emit('cancel')">
        {{ $t('AcceptPdpa.cancel') }}
      </button>
      <button class="accept-button" @click="$emit('accept')">
        {{ $t('AcceptPdpa.accept') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AcceptPdpa',
  data () {
    return {
      input: ''
    }
  },
  computed: {
  },
  created () {
    var self = this
    self.loadFile()
  },
  mounted () {
  },
  methods: {
    loadFile () {
      axios({
        method: 'get',
        url: '/static/privacy.html'
      }).then(result => {
        this.input = result.data
      }).catch(error => {
        console.log(error)
      })
    }
  },
  watch: {
  }
}
</script>

<style scoped>
  .accept-pdpa {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    padding: 24px;
    box-sizing: border-box;
    background-image: url(/static/image_asset/white_background_2560.png);
    background-position: center bottom;
    background-size: cover;
    z-index: 1000;
  }

  .title {
    font-family: Prompt;
    color: rgb(34, 84, 156);
    font-size: 24px;
    padding-bottom: 24px;
  }

  .content {
    width: 100%;
    height: calc(100% - 36px - 24px - 24px - 48px);
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    border-radius: 10px;
  }

  .action {
    padding-top: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  button.cancel-button {
    margin: 0px 0px 0px auto;
    border: none;
    background-color: rgb(74, 74, 74);
    border-radius: 24px;
    color: rgb(255, 255, 255);
    height: 48px;
    padding: 0px 24px;
    box-sizing: border-box;
    font-size: 18px;
    cursor: pointer;
    font-family: Prompt;
  }

  button.accept-button {
    margin: 0px 0px 0px 24px;
    border: none;
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    border-radius: 24px;
    color: rgb(255, 255, 255);
    height: 48px;
    padding: 0px 24px;
    box-sizing: border-box;
    font-size: 18px;
    cursor: pointer;
    font-family: Prompt;
  }
</style>


// WEBPACK FOOTER //
// src/components/AcceptPdpa.vue